import React, { useState } from 'react';
import {
  Box,
  Button,
  ButtonGroup,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Paper,
  Typography
} from '@mui/material';
import {
  CalendarMonth,
  Today
} from '@mui/icons-material';

interface DateRangePickerProps {
  value: string;
  onChange: (value: string) => void;
  size?: 'small' | 'medium';
  variant?: 'outlined' | 'filled' | 'standard';
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  value,
  onChange,
  size = 'small',
  variant = 'outlined'
}) => {
  const quickPeriods = [
    { value: '24h', label: '24h' },
    { value: '72h', label: '72h' },
    { value: '7d', label: '7d' },
    { value: '30d', label: '30d' },
    { value: '90d', label: '90d' }
  ];

  return (
    <Box>
      <FormControl size={size} variant={variant} sx={{ minWidth: 150 }}>
        <InputLabel>Period</InputLabel>
        <Select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          label="Period"
        >
          {quickPeriods.map((period) => (
            <MenuItem key={period.value} value={period.value}>
              {period.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default DateRangePicker;

